import { useParams } from 'react-router-dom';
import { useFetchItem, useSave } from './service';
import { Form } from './Form';

import { resourceName } from './settings';
import ContainerLayout from '@/components/Layout/ContainerLayout';
import HeaderLayout from '@/components/Layout/HeaderLayout';
import { Box } from '@chakra-ui/react';

export function PermissaoFiliaisEdit() {
  const { id } = useParams();
  const { data, isLoading } = useFetchItem(id || '');
  const { mutateAsync: handleSave } = useSave(id);

  return (
    <ContainerLayout>
      <HeaderLayout
        breadcrumbActived
        title={resourceName}
      />
      <Box p={5}>
        <Form
          defaultValues={data}
          isLoading={isLoading}
          handleSave={handleSave}
        />
      </Box>
    </ContainerLayout>
  );
}
